import type { TraceIdContextStateType } from './types';

export const state: TraceIdContextStateType = {
	context: null,
};
